import { Star } from "lucide-react";
import { REVIEWS } from "./content";

const ReviewCard = ({ review }) => (
  <article
    className="h-full rounded-2xl border border-[var(--line)] bg-white p-5 sm:p-6"
    data-testid={`review-${review.name.toLowerCase().replaceAll(" ", "-")}`}
  >
    <div className="flex items-center justify-between gap-3">
      <h3 className="text-base font-bold text-[var(--ink)]">{review.name}</h3>
      <span className="shrink-0 text-sm font-semibold text-[var(--ink-soft)]">
        {review.rating}/5
      </span>
    </div>
    <blockquote className="mt-3 leading-relaxed text-[var(--ink-soft)]">
      “{review.text}”
    </blockquote>
  </article>
);

export const WorkReviews = () => (
  <section id="omdomen" className="bg-[var(--paper)] py-12 md:py-16" data-testid="reviews-section">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="eyebrow">Omdömen</p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">
            Vad kunderna säger
          </h2>
        </div>
        <div>
          <div className="flex items-center gap-2">
            <Star size={19} fill="currentColor" className="text-[var(--red)]" aria-hidden />
            <strong className="text-2xl text-[var(--ink)]">4,7/5</strong>
            <span className="text-sm text-[var(--ink-soft)]">· 3 omdömen på Reco</span>
          </div>
        </div>
      </div>

      <div className="mt-7 grid gap-4 md:grid-cols-3">
        {REVIEWS.map((review) => <ReviewCard key={review.name} review={review} />)}
      </div>
    </div>
  </section>
);
